import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi2";
import { NegativeInfluencesLog } from "../../types/post";
import {
  useLogCardActions,
  LogCardActionsProps,
} from "../../hooks/useLogCardActions";
import LogCard from "../shared/LogCard";
import {
  LogCardChip,
  LogCardMetricsRow,
  LogCardNote,
} from "../shared/LogCardContent";

interface NegativeInfluencesLogCardProps
  extends LogCardActionsProps<NegativeInfluencesLog & { id: string }> {
  log: NegativeInfluencesLog & { id: string };
}

const NegativeInfluencesLogCard: React.FC<NegativeInfluencesLogCardProps> = ({
  log,
  onDelete,
  onEdit,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { handleDelete, handleEdit } = useLogCardActions(log, {
    onDelete,
    onEdit,
  });

  const handleCardClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div onClick={handleCardClick} className="cursor-pointer">
      <LogCard
        className={isExpanded ? "bg-base-100" : "bg-red-500/10"}
        onDelete={onDelete ? handleDelete : undefined}
        onEdit={onEdit ? handleEdit : undefined}
      >
        {/* Header */}
        <div className="flex items-center gap-2 pr-8">
          <span className="text-[11px] font-medium tracking-wide uppercase text-base-content/70 font-geist">
            Negative Influences
          </span>
          {log.notes && (
            <HiChevronDown
              className={`w-3 h-3 text-base-content/30 transition-transform duration-200 ml-auto ${
                isExpanded ? "rotate-180" : ""
              }`}
            />
          )}
        </div>

        {/* Negative influences as chips */}
        <div className="mt-1.5">
        <LogCardMetricsRow gap={1}>
            {log.selectedInfluences.map((influence, index) => (
            <LogCardChip key={index} label={influence} variant="warning" />
            ))}
        </LogCardMetricsRow>
        </div>

        {/* Expanded notes */}
        {isExpanded && log.notes && (
          <div className="mt-2">
            <LogCardNote text={log.notes} />
          </div>
        )}
      </LogCard>
    </div>
  );
};

export default NegativeInfluencesLogCard;